<template>
    <x-dialog :visible="visible" :config="getDialogConfig(config)"
        @close="$emit('close')"
        @update:visible="(visible)=> $emit('update:visible', visible)"
    >
        <x-step-view
            :config="config"
            v-model:data="modelValue"
            @update:data="confirmHandler"
            @cancel="closeHandler"
        ></x-step-view>
    </x-dialog>
</template>
<script setup>
import { defineProps, getCurrentInstance, ref, watch } from 'vue';
import XDialog from './XDialog.vue';
import XStepView from '../viewmodule/XStepView.vue';

const inst = getCurrentInstance();

const props = defineProps({
    visible: { default: true },
    config: { default: null },
    dataOptions: { default: null },

    data: { default: null },
})

defineEmits({
    'close': null,
    'update:visible': null,
    'update:modelValue': null,
    'confirm': null,
})

const modelValue = ref(null);
watch(()=> props.data, (value)=> {
    modelValue.value = value;
}, {immediate:true});

const getDialogConfig = (config)=> {
    config.buttons = null;
    config.withDefaultButtons = false;
    return config;
}

const confirmHandler = (value)=> {
    inst.emit('confirm', {data:value}, 'CONFIRM');
    inst.emit('close', 'CLOSE');
}
const closeHandler = ()=> {
    inst.emit('close', 'CLOSE');
}
</script>
<style>
.x-dialog .x-step-view {
    margin-bottom: -10px;
}
</style>